module.exports = __webpack_public_path__ + "static/img/financijskekarticeulozi.13840c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/financijskekarticeulozi.png
// module id = jV8I
// module chunks = 0